export class DeleteWorkItemDto {
  workItemId: any[] = [];
  queueId: number = 0;
  workflowId: number = 0;
  userGpid: string = '';
  systemId: number = 0;
}
